import cn from 'classnames';
import { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import { TagsCell } from '@/creditflowresearch/ui/common/components/TableCells';
import AttributeCell
  from '@/creditflowresearch/ui/components/creditFlow/Stats/StatsTable/cellCallbacks/AttributeCell';
import NameCell from '@/creditflowresearch/ui/components/creditFlow/Stats/StatsTable/cellCallbacks/NameCell';
import UpdatedAtCell from '@/creditflowresearch/ui/components/creditFlow/Stats/StatsTable/cellCallbacks/UpdatedAtCell';

import textStyles from '@creditflowresearch/uilib/styles/helpers/text.module.scss';
import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const columns: IColumn[] = [
  {
    title: 'Name',
    name: 'name',
    cellCallback: NameCell,
  },
  {
    title: 'Categories',
    name: 'categoriesNames',
    maxWidth: 350,
    className: cn(alignStyles.alignRight, textStyles.nowrap),
    cellCallback: TagsCell,
  },
  {
    title: 'Product',
    name: 'products',
    width: 115,
    maxWidth: 115,
    cellCallback: (cellProps) => <AttributeCell { ...cellProps } countItemVisible={ 3 } />,
  },
  {
    title: 'Market',
    name: 'markets',
    width: 130,
    maxWidth: 130,
    cellCallback: AttributeCell,
  },
  {
    title: 'Date',
    name: 'updatedAt',
    width: 113,
    maxWidth: 113,
    className: cn(alignStyles.alignRight, textStyles.nowrap),
    cellCallback: (cellProps) => <UpdatedAtCell row={ cellProps.row } />,
  },
];

export default columns;
